// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U0CGr","selected":"styles_selected__1tDbh"};